import { Component, OnInit } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service"
import { CacheService } from "../../_services/cache.service"
import { AuthenticationService } from "../../_services/authentication.service"
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-listings-search-page',
  templateUrl: './listings-search-page.component.html',
  styleUrls: ['./listings-search-page.component.css']
})
export class ListingsSearchPageComponent implements OnInit {


  protected searchQuery
  protected searchResults
  protected currentPage = 1;
  protected totalPages;
  protected loading

  protected userFavorites;
  protected maxFavorites = environment.maxFavorites;

  private cacheKey;

  private listingsSearchSubscription: Subscription;
  private userFavoritesSubscription: Subscription;

  constructor(private astrolyticsService: AstrolyticsService, private route: ActivatedRoute, private cs:CacheService, private as: AuthenticationService) { }
  
  ngOnInit() {
    this.loading = false
    this.searchQuery = this.route.snapshot.queryParamMap.get("q") ? this.route.snapshot.queryParamMap.get("q") : ""

    this.cacheKey = "favorites-data-"+this.as.currentUserValue.id;

    this.listingsSearchSubscription = this.astrolyticsService.listingsSearchObservable.subscribe((response) => {
      this.loading = false
      if (response) {        
        this.searchResults = response.results;
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        console.log(response);
      } else {
        this.searchResults = []
      }
    })

    this.userFavoritesSubscription = this.astrolyticsService.userFavoritesObservable.subscribe(message => {
      if (message) {
        console.log(message);
        
        this.userFavorites = message
      }
    })

    if (this.searchQuery) {
      this.performSearch()
    }

    this.astrolyticsService.getUserFavorites(this.as.currentUserValue.id)
  }

  ngOnDestroy(): void {    
    this.listingsSearchSubscription.unsubscribe()
    this.userFavoritesSubscription.unsubscribe()
  }

  performSearch(page = 1) {
    this.loading = true
    this.searchResults = []

    this.astrolyticsService.searchListings(this.searchQuery, page)
  }

  onFav(element_id, resource_type) {    
    if (this.userFavorites[resource_type].includes(element_id)) {
      let index = this.userFavorites[resource_type].indexOf(element_id)
      this.userFavorites[resource_type].splice(index, 1)
      this.updateFavs()
      if (resource_type == "listings") {
        this.deleteFavData(element_id)
      }
    } else {
      if (this.userFavorites[resource_type].length < this.maxFavorites) {
        this.userFavorites[resource_type].push(element_id)
        this.updateFavs()
              if (resource_type == "listings") {
                this.createFavData(element_id)
              }
      } else {
        //Avisar que no se puede 
        let alert: any = $('.alert')
        alert.show({ easing: "swing" })
        setTimeout(() => {
          alert.hide({ duration: 500 })
        }, 5000);
      }
    }
  }

  updateFavs() {
    var user_id = this.as.currentUserValue.id
    this.astrolyticsService.updateUserFavorites(this.userFavorites, user_id)
    this.cs.clearCache(this.cacheKey);
  }

  deleteFavData(meliId) {
    var userId = this.as.currentUserValue.id
    this.astrolyticsService.deleteUserFavData(userId, meliId)   
    this.cs.clearCache(this.cacheKey);
  }
  
  createFavData(meliId) {
    var userId = this.as.currentUserValue.id
    this.astrolyticsService.createUserFavData(userId, meliId)   
    this.cs.clearCache(this.cacheKey);
  }
  
}
